import { arrayOfType } from '../../../../../shared/utils/data.utils';

export interface IScorecard {
  accountId: number;
  assignedSitesCount: number;
  scorecardId: number;
  scorecardKey: string;
  scorecardName: string;
  totalSitesCount: number;
  version: number;
  lastUpdated: Date | string;
}

export class Scorecard implements IScorecard {
  accountId: number = 0;
  assignedSitesCount: number = 0;
  scorecardId: number = 0;
  scorecardKey: string = '';
  scorecardName: string = '';
  totalSitesCount: number = 0;
  version: number = 0;
  lastUpdated: Date | string = '';

  constructor(data: IScorecard) {
    if (data) {
      this.accountId = data.accountId ?? 0;
      this.assignedSitesCount = data.assignedSitesCount ?? 0;
      this.scorecardId = data.scorecardId ?? 0;
      this.scorecardKey = data.scorecardKey ?? '';
      this.scorecardName = data.scorecardName ?? '';
      this.totalSitesCount = data.totalSitesCount ?? 0;
      this.version = data.version ?? 0;
      this.lastUpdated = data.lastUpdated ? new Date(data.lastUpdated) : '';
    }
  }
}

export interface IAccountScorecards {
  accountId: number;
  accountName: string;
  scorecards: IScorecard[];
}

export class AccountScorecards implements IAccountScorecards {
  accountId: number = 0;
  accountName: string = '';
  scorecards: IScorecard[] = [];

  constructor(data: IAccountScorecards) {
    if (data) {
      this.accountId = data.accountId ?? 0;
      this.accountName = data.accountName ?? '';
      this.scorecards = arrayOfType<IScorecard>(data.scorecards, Scorecard) ?? [];
    }
  }
}
